import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTransferArrowRight = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M5.729 10.5573H13.6079L11.6548 12.5104H12.7603L15.104 10.1666L12.7603 7.82288H11.6548L13.6079 9.776H5.729V10.5573Z",
		fill: "#34A853"
	})]
});
export default SvgTransferArrowRight;
